import { View, StyleSheet } from "react-native";
import BlankLayout from "../layouts/BlankLayout";
import LoginFormContainer from "../containers/auth/LoginFormContainer/LoginFormContainer";
import useResponsiveScreen from "../hooks/useResponsiveScreen";
import { useAuth } from "../hooks/useAuth";
import { NavigationProp, RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { useAppConfig } from "../AppConfigProvider";
import { useEffect } from "react";
import { RootStackParamList } from "../navigation/AppNavigator.web";

function LoginView(isLMS = false) {
  const { isLarge } = useResponsiveScreen();
  const { isAuthenticated, isEmailVerified, otpVerifiedForSession } = useAuth();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const route = useRoute<RouteProp<RootStackParamList, "LoginSuperAdmin">>();
  const appConfig = useAppConfig();
  const isCompanionMode = appConfig.isCompanionMode;

  const isSuperAdminRoute = route.name === "LoginSuperAdmin";

  useEffect(() => {
    if (isAuthenticated && isEmailVerified && otpVerifiedForSession) {
      if (isCompanionMode) {
        navigation.navigate("Companion");
      } else {
        navigation.navigate("Home");
      }
    }
  }, [isAuthenticated, isEmailVerified, otpVerifiedForSession, navigation, isCompanionMode]);

  return isLarge ? (
    <BlankLayout>
      <View style={[styles.webContainer, { width: !isLMS ? "40%" : "100%" }]}>
        <LoginFormContainer isSuperAdminRoute={isSuperAdminRoute} />
      </View>
    </BlankLayout>
  ) : (
    <BlankLayout>
      <View style={styles.mobileContainer}>
        <View style={{ padding: 15 }}>
          <LoginFormContainer isSuperAdminRoute={isSuperAdminRoute} />
        </View>
      </View>
    </BlankLayout>
  );
}

const styles = StyleSheet.create({
  webContainer: {
    justifyContent: "center",
    alignItems: "center",
    padding: 30,
  },
  mobileContainer: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",

    width: "100%",
  },
});

export default LoginView;
